import { authRoles } from "../../../auth/authRoles";
import Data from "./Data/Data";
import DetailData from "./Data/DetailData";
import EditData from "./Data/EditData";
import TambahData from "./Data/TambahData";
import EditKategori from "./Kategori/EditKategori";
import Kategori from "./Kategori/Kategori";
import TambahKategori from "./Kategori/TambahKategori";

const ManajemenPerusahaanRoutes = [
  {
    path: "/kategori_manajemen/edit/:id",
    exact: true,
    component: EditKategori,
    auth: authRoles.all,
  },
  {
    path: "/kategori_manajemen/tambah",
    exact: true,
    component: TambahKategori,
    auth: authRoles.all,
  },
  {
    path: "/kategori_manajemen",
    exact: true,
    component: Kategori,
    auth: authRoles.all,
  },
  {
    path: "/data_manajemen/detail/:id",
    exact: true,
    component: DetailData,
    auth: authRoles.all,
  },
  {
    path: "/data_manajemen/edit/:id",
    exact: true,
    component: EditData,
    auth: authRoles.all,
  },
  {
    path: "/data_manajemen/tambah",
    exact: true,
    component: TambahData,
    auth: authRoles.all,
  },
  {
    path: "/data_manajemen",
    exact: true,
    component: Data,
    auth: authRoles.all,
  },
];

export default ManajemenPerusahaanRoutes;
